import { jsx as c } from "react/jsx-runtime";
import { forwardRef as D, useRef as E, useState as F, useCallback as L } from "react";
import { useOnClickOutside as U } from "@placer-ui/hooks";
import { BaseCompactSelect as _ } from "./index.es855.js";
import { ChipSelectorSelect as y } from "./index.es856.js";
import { LabeledField as b } from "./index.es512.js";
import { mergeRefs as a } from "./index.es551.js";
import { BaseSelectBox as d } from "./index.es834.js";
const g = "unified-select-box-default-testid", J = D(
  ({
    testId: e = g,
    label: O,
    required: u,
    feedback: C,
    asterix: x,
    infoTooltip: B,
    isError: f = !1,
    disabled: t = !1,
    value: o,
    size: i,
    isOpen: I,
    onClick: r,
    ...m
  }, p) => {
    const n = E(null), [s, S] = F(I), R = i === "compact", T = Array.isArray(o), l = L(
      (h) => {
        S((A) => !A), r == null || r(h);
      },
      [r]
    );
    return U(() => S(!1), n), /* @__PURE__ */ c(
      b,
      {
        label: O,
        required: u,
        feedback: C,
        asterix: x,
        disabled: t,
        isError: f,
        testId: `${e}-label`,
        infoTooltip: B,
        children: R ? /* @__PURE__ */ c(
          _,
          {
            testId: e,
            value: o,
            disabled: t,
            ...m,
            onClick: l,
            isOpen: s,
            ref: a(p, n)
          }
        ) : T ? /* @__PURE__ */ c(
          y,
          {
            testId: e,
            value: o,
            disabled: t,
            isError: f,
            size: i,
            ...m,
            onClick: l,
            isOpen: s,
            ref: a(p, n)
          }
        ) : /* @__PURE__ */ c(
          d,
          {
            testId: e,
            value: o,
            disabled: t,
            isError: f,
            size: i,
            ...m,
            onClick: l,
            isOpen: s,
            ref: a(p, n)
          }
        )
      }
    );
  }
);
export {
  g as UNIFIED_SELECT_DEFAULT_TESTID,
  J as UnifiedSelectBox
};
//# sourceMappingURL=index.es63.js.map
